// V1-COMPAT: stands in for views_shared_copies/api/withTokenRefresh.js (aliased in config/webpack/base.js).
import { fetchWithTokenRefresh as fetchWithV1TokenRefresh, getCSRFToken, refreshAccessToken } from './fetchWithTokenRefresh';

const resolveApiUrl = (url) => {
  if (!globalThis.Qwoted?.V1_HOSTED) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const v2Url = globalThis.Qwoted?.V2_URL;
  return v2Url ? `${v2Url}${url}` : url;
};

export { getCSRFToken, refreshAccessToken };

export const fetchWithTokenRefresh = (url, options = {}, config = {}) => (
  fetchWithV1TokenRefresh(resolveApiUrl(url), options, { ...config, redirectOnAuthFailure: false })
);
